import type { StudentLectureDtoT } from '@mathflat/domain/@entities/StudentLecture'

import maxios from '../utils/maxios'

export const studentLectureApi = {
  getAssignments: async (params: StudentLectureDtoT.GetStudentLectureAssignmentsRequest) => {
    return await maxios.get<StudentLectureDtoT.GetStudentLectureAssignmentsResponse>(
      '/student-lecture/assignments',
      { params },
    )
  },
}
